import * as types from '../types/similarTypes';
import * as similarService from '../../services/similarService';
import { addVote } from '../../utils/activityStore';

export const fetchSimilarList = (category, id, { language } = {}) => async (dispatch) => {
  dispatch({ type: types.FETCH_SIMILAR_REQUEST });
  try {
    const data = await similarService.getSimilarList(category, id, { language });
    dispatch({ type: types.FETCH_SIMILAR_SUCCESS, payload: data.results || [] });
  } catch (err) {
    dispatch({
      type: types.FETCH_SIMILAR_FAILURE,
      payload: err?.response?.data?.error || err?.message || 'Failed to load similar picks',
    });
  }
};

export const submitSimilarityVote =
  (category, baseId, { alternativeCategory, alternativeId, rating, reason, baseTitle, altTitle, language } = {}) =>
  async (dispatch) => {
    dispatch({ type: types.VOTE_SUBMIT_START, payload: alternativeId });
    try {
      addVote({
        baseTitle: baseTitle || `#${baseId}`,
        altTitle: altTitle || `#${alternativeId}`,
        rating,
        reason,
      });
      await similarService.submitSimilarityVote(category, baseId, {
        alternativeCategory,
        alternativeId,
        rating,
        reason: reason || '',
      });
      const data = await similarService.getSimilarList(category, baseId, { language });
      dispatch({ type: types.FETCH_SIMILAR_SUCCESS, payload: data.results || [] });
    } catch (err) {
      dispatch({
        type: types.FETCH_SIMILAR_FAILURE,
        payload: err?.response?.data?.error || err?.message || 'Failed to submit vote',
      });
    } finally {
      dispatch({ type: types.VOTE_SUBMIT_END });
    }
  };

